import { useQuery, UseQueryResult } from '@taxdown/zeno-sama-query';
import { getErrorDetail } from 'Services/errors';
import Notify, { AlertTypes } from 'Services/notification';
import RecordsService from 'Services/records';
import { QueryKeys, RecordType, ResponseType, SaveDataType } from 'Types/common';

export const useSaveUserData = (
  serviceData: SaveDataType,
  section: string,
  onSuccess: (response: ResponseType<RecordType>) => void
): UseQueryResult<ResponseType<RecordType>> =>
  useQuery([QueryKeys.SAVE_USER_DATA, section], () => RecordsService.setUserData(serviceData), {
    onSuccess: response => onSuccess(response),
    onError: error => Notify.sendNotification(getErrorDetail(error), AlertTypes.error),
    cacheTime: 0,
  });
